// This file is part of the Content application for the Strapi project.
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SEOLandingPageShellComponent } from './containers/seo-landing-page-shell/seo-landing-page-shell.component';
import { authGuard } from '../common/guards/auth.guard';

const routes: Routes = [
  {
    path: 'tv',
    children: [
      {
        path: '360-upgrade',
        redirectTo: 'upgrade-360-now',
        pathMatch: 'full',
      },
      {
        path: 'upgrade-360-now',
        component: SEOLandingPageShellComponent,
        data: { strapiLevel1Prefix: 'tv', strapiUID: 'upgrade-360-now' },
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: ':strapiUID',
    component: SEOLandingPageShellComponent,
  },
  {
    path: ':strapiLevel1Prefix',
    children: [
      {
        path: ':strapiUID',
        component: SEOLandingPageShellComponent,
      },
    ],
  },
  {
    path: ':strapiLevel1Prefix',
    children: [
      {
        path: ':strapiLevel2Prefix',
        children: [
          {
            path: ':strapiUID',
            component: SEOLandingPageShellComponent,
          },
        ],
      },
    ],
  },
  {
    path: ':strapiLevel1Prefix',
    children: [
      {
        path: ':strapiLevel2Prefix',
        children: [
          {
            path: ':strapiLevel3Prefix',
            children: [
              {
                path: ':strapiUID',
                component: SEOLandingPageShellComponent,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: ':strapiLevel1Prefix',
    children: [
      {
        path: ':strapiLevel2Prefix',
        children: [
          {
            path: ':strapiLevel3Prefix',
            children: [
              {
                path: ':strapiLevel4Prefix',
                children: [
                  {
                    path: ':strapiUID',
                    component: SEOLandingPageShellComponent,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SEOLandingPageRoutingModule {}
